import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssessmentSettingsComponent } from './assessment-settings/assessment-settings.component';

const routes: Routes = [
	{ path: '', children: [
		{ path: '', component: AssessmentSettingsComponent }
	] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssessmentRoutingModule { }
